/**
 * „Musterkarten bis 3 € gratis" — vzorníky barev do 3 € zdarma.
 *
 * PRAVIDLO (upřesnění majitele 9. 9. 2026) je ÚTES, ne sleva:
 * do 3 € včetně zdarma, nad 3 € platí zákazník PLNOU cenu všech vzorníků
 * a dostane ji zpět jako Anrechnung při první objednávce nad 500 €.
 *
 * PROČ SKRIPT A NE NASTAVENÍ:
 * Automatická sleva Shopify umí jen „odečti 3 €" — nad limitem tím dávala
 * 3 € navíc (košík za 4,20 € platil 1,20 €). Maximum requirement automatické
 * slevy neznají a vlastní Shopify Function smí jen Plus. Proto: beptum-admin
 * vydá jednorázový kód na 100 % z kolekce Musterfarben a tenhle skript ho
 * v košíku uplatní — nebo zase odebere, když zákazník limit přeleze.
 *
 * Zásady:
 *  - běží jen na /cart (jinde se cena neukazuje a checkout si kód nese sám),
 *  - o nároku rozhoduje VÝHRADNĚ server; klient posílá jen varianty a množství,
 *  - sahá jen na VLASTNÍ kódy (prefix MUSTERGRATIS-) — cizí ani kredit
 *    (MUSTER-) nikdy neodebírá,
 *  - Shopify pustí jen jeden kód: když už je v košíku jiný, nic neděláme.
 */
(function () {
  const PREFIX = 'MUSTERGRATIS-';
  const CREDIT_PREFIX = 'MUSTER-';
  let busy = false;

  function apiBase() {
    const el = document.querySelector('[data-bp-admin-api-base]');
    return (window.bpAdminApiBase || (el && el.getAttribute('data-bp-admin-api-base')) || '').replace(/\/+$/, '');
  }

  /** Hláška v souhrnu košíku (snippets/cart-summary.liquid) — jen když nárok padl. */
  function showNotice(text, loginUrl) {
    document.querySelectorAll('[data-bp-muster-notice]').forEach((el) => {
      // Zapisovat jen při změně — každý zápis je mutace DOM a ta spouští sync()
      // znovu (bez téhle podmínky smyčka každých 600 ms až do 429 z API).
      const next = text || '';
      const key = next + '|' + (loginUrl || '');
      if (el.dataset.bpNoticeKey !== key) {
        el.dataset.bpNoticeKey = key;
        el.textContent = next;
        // T-76: host — odkaz na přihlášení (vzorky zdarma jen s účtem)
        if (next && loginUrl) {
          const a = document.createElement('a');
          a.href = loginUrl;
          a.textContent = (window.bpLocale || '').indexOf('en') === 0 ? 'Log in' : 'Jetzt anmelden';
          a.style.marginLeft = '6px';
          a.style.textDecoration = 'underline';
          el.appendChild(a);
        }
      }
      if (el.hidden !== !next) el.hidden = !next;
    });
  }

  function appliedCodes(cart) {
    return (cart.discount_codes || [])
      .filter((d) => d.applicable !== false)
      .map((d) => d.code);
  }

  /** Přepíše seznam kódů v košíku. Vrací true, když se stav opravdu změnil. */
  async function setCodes(codes, previous) {
    const next = codes.join(',');
    if (next === previous.join(',')) return false;
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: next }),
    });
    return res.ok;
  }

  /** Pojistka proti smyčce (kód se mění a stránka obnovuje dokola): max 3 obnovení za minutu. */
  function reloadAllowed() {
    try {
      const now = Date.now();
      const times = JSON.parse(sessionStorage.getItem('bp_mf_reloads') || '[]').filter((t) => now - t < 60000);
      if (times.length >= 3) return false;
      times.push(now);
      sessionStorage.setItem('bp_mf_reloads', JSON.stringify(times));
    } catch (e) {
      /* bez úložiště radši obnovit */
    }
    return true;
  }

  async function sync() {
    if (busy || !window.location.pathname.includes('/cart')) return;

    const base = apiBase();
    if (!base) return;

    let cart;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      cart = await res.json();
    } catch (e) {
      return; // výpadek sítě nesmí rozbít košík
    }
    if (!cart || !cart.items || cart.items.length === 0) return;

    const codes = appliedCodes(cart);
    const ours = codes.filter((c) => c.toUpperCase().indexOf(PREFIX) === 0);
    const foreign = codes.filter((c) => c.toUpperCase().indexOf(PREFIX) !== 0);

    // Kredit nad 500 € (MUSTER-) i ručně zadaný kód mají přednost — Shopify
    // pustí jen jeden a přebít cizí slevu nám nepřísluší.
    const hasForeign = foreign.length > 0;

    let data;
    try {
      const res = await fetch(base + '/api/muster/free', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: cart.items.map((i) => ({ variant_id: String(i.variant_id), quantity: i.quantity })),
          customer_id: window.bpCustomerId ? String(window.bpCustomerId) : null,
          locale: window.bpLocale || document.documentElement.lang || 'de',
          // Host nemá identitu — bez kódu, který už má v košíku, by server vydal
          // pokaždé nový a my bychom ho měnili a stránku obnovovali dokola.
          code: ours[0] || null,
        }),
      });
      data = await res.json();
    } catch (e) {
      return;
    }
    if (!data) return;

    // over_limit / limit_used = zákazník platí plnou cenu — ať ví proč.
    // login_required (T-76) = host — vzorky zdarma až po přihlášení, s odkazem
    const noticeOn = !data.success && ['over_limit', 'limit_used', 'login_required'].indexOf(data.message) !== -1;
    showNotice(noticeOn ? data.text : '', noticeOn && data.message === 'login_required' ? (window.bpLoginUrl || '/account/login') : '');

    busy = true;
    try {
      let changed = false;

      if (data.success && data.code) {
        if (ours.indexOf(data.code) === -1 && !hasForeign) {
          changed = await setCodes(foreign.concat([data.code]), codes);
        }
      } else if (ours.length > 0) {
        // Nárok padl (typicky over_limit — zákazník přidal další vzorník).
        // Náš kód musí pryč, jinak by měl vzorky zdarma i nad limitem.
        changed = await setCodes(foreign, codes);
      }

      if (changed && reloadAllowed()) window.location.reload();
    } catch (e) {
      /* nechat košík být */
    } finally {
      busy = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  // Košík se překresluje bez reloadu (změna množství, mazání) — po uklidnění DOM znovu.
  let timer = null;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(sync, 600);
  }).observe(document.body, { childList: true, subtree: true });
})();
